import {
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
  SettingOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  VideoCameraFilled,
} from "@ant-design/icons";
import { IMainMenu } from "../types";

export const mainMenu: IMainMenu[] = [
  {
    id: -1,
    key: 'home',
    icon: <UserOutlined />,
    label: 'Home',
    link: '/',
  },
  {
    id: 2,
    key: '2',
    icon: <VideoCameraOutlined />,
    label: 'Drone parts',
    link: '/drone-parts',
  },
  
  {
    id: 8,
    key: '8',
    icon: <VideoCameraFilled />,
    label: 'Products',
    link: '/drones',
  },
  {
    id: 7,
    key: '7',
    icon: <SettingOutlined />,
    label: 'Settings',
    link: '/settings',
  },
  {
    id: 9,
    key: '9',
    icon: <ShoppingCartOutlined />,
    label: 'Orders',
    link: '/orders',
  },
  {
    id: 11,
    key: '11',
    icon: <SettingOutlined />,
    label: 'Legacy',
    link: '/v1',
    children: [
      {
        id: 1,
        key: '1',
        icon: <UserOutlined />,
        label: 'Electronics',
        link: '/electronics',
      },
      {
        id: 3,
        key: '3',
        icon: <UploadOutlined />,
        label: 'Drone complects',
        link: '/drone-complects',
      },
      {
        id: 4,
        key: '4',
        icon: <ShoppingCartOutlined />,
        label: 'Store',
        link: '/store',
      },
  
      {
        id: 5,
        key: '5',
        icon: <ShopOutlined />,
        label: 'Suppliers',
        link: '/suppliers',
      },
    ],
  },
  {
    id: 10,
    key: '10',
    icon: <SettingOutlined />,
    label: 'V2',
    link: '/v2',
    children: [
      {
        id: 11,
        key: '11',
        icon: <SettingOutlined />,
        label: 'Home V2',
        link: '/v2',
      },
      {
        id: 12,
        key: '12',
        icon: <SettingOutlined />,
        label: 'Suppliers V2',
        link: '/v2/suppliers',
      },
      {
        id: 13,
        key: '13',
        icon: <SettingOutlined />,
        label: 'Stock V2',
        link: '/v2/stock',
      },
      {
        id: 14,
        key: '14',
        icon: <SettingOutlined />,
        label: 'Products V2',
        link: '/v2/products',
      },
      {
        id: 15,
        key: '15',
        icon: <SettingOutlined />,
        label: 'Drafts V2',
        link: '/v2/drafts',
      },
      {
        id: 16,
        key: '16',
        icon: <SettingOutlined />,
        label: 'Settings V2',
        link: '/v2/settings',
      },
      {
        id: 17,
        key: '17',
        icon: <SettingOutlined />,
        label: 'Orders V2',
        link: '/v2/orders',
      },
      {
        id: 18,
        key: '18',
        icon: <SettingOutlined />,
        label: 'Helpful Links',
        link: '/v2/links',
      },
    ],
  },
];
